export default __webpack_public_path__ + "static/media/iconVirtual.f46bfd42.svg";